<template>
  <div class="guest-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/index' }">数据概览</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/index' }">应用中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/shell/index' }">会议壳</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/shell/meeting-list' }">会议列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{this.$route.query.itemName}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/shell/content/index/' + this.$route.params.mId }">会议内容管理</el-breadcrumb-item>
      <el-breadcrumb-item>嘉宾管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <div class="content-header">
        <el-button type="primary" size="mini" @click="addGuest">添加嘉宾</el-button>
      </div>
      <div class="guest-list" v-if="dataList.length > 0">
        <div class="guest-item" v-for="item in dataList" :key="item.id">
          <div class="avatar">
            <img :src="item.avatar"/>
          </div>
          <div class="info">
            <div class="name">{{item.name}}</div>
            <div class="tags">
              <div class="item" v-for="(items, index) in item.tags" :key="index">
                {{items}}
              </div>
            </div>
          </div>
          <div class="item-options">
            <div class="edit" @click="editItem(item.id)">编辑</div>
            <div class="del" @click="delItem(item.id)">删除</div>
          </div>
        </div>
      </div>
      <div class="no-list" v-else>
        <el-empty :image-size="200"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      dataList: []
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    // 获取会议列表
    async getDataList () {
      const { data: res } = await this.$http.get('/shell-guest-list', { params: { mId: this.$route.params.mId } })
      if (res.status === 200) {
        this.dataList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    // 添加
    addGuest () {
      this.$router.push({ path: '/admin/apps/shell/content/guest/' + this.$route.params.mId + '/add', query: { meetingName: this.$route.query.itemName } })
    },
    // 编辑
    editItem (id) {
      this.$router.push({ path: '/admin/apps/shell/content/guest/' + this.$route.params.mId + '/edit/' + id, query: { meetingName: this.$route.query.itemName } })
    },
    // 删除
    async delItem (id) {
      const { data: res } = await this.$http.delete('/shell-guest/' + id)
      if (res.status === 200) {
        this.$message.success(res.msg)
        await this.getDataList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
.content-header{
  text-align: right;
}
.guest-list{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 20px;
}
.guest-list .guest-item{
  width: 200px;
  height: auto;
  background-color: rgba(255,255,255,1);
  margin: 0 20px 20px 0;
  position: relative;
  padding-bottom: 24px;
}
.guest-list .guest-item:hover{
  box-shadow: rgb(0 0 0 / 15%) 0px 15px 25px, rgb(0 0 0 / 5%) 0px 5px 10px;
}
.guest-list .guest-item .avatar{
  width: 200px;
  height: 200px;
  background-color: #2d8cf0;
}
.guest-list .guest-item .avatar img{
  width: 100%;
  height: 100%;
}
.guest-list .guest-item .info {
  padding: 4px;
}
.guest-list .guest-item .info .name{
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}
.guest-list .guest-item .info .tags{
  display: flex;
  flex-wrap: wrap;
}
.guest-list .guest-item .info .tags .item{
  font-size: 12px;
  background-color: rgba(0,0,0,0.1);
  padding: 4px;
  border-radius: 4px;
  margin: 0 4px 4px 0;
}
.guest-list .guest-item .item-options{
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
}
.guest-list .guest-item .item-options .edit{
  background-color: #409EFF;
  color: #FFFFFF;
  font-size: 13px;
  line-height: 26px;
  cursor: pointer;
  flex: 1;
  text-align: center;
}
.guest-list .guest-item .item-options .del{
  background-color: #F56C6C;
  color: #FFFFFF;
  font-size: 13px;
  line-height: 26px;
  cursor: pointer;
  flex: 1;
  text-align: center;
}
</style>
